var map = {
	"./KMY.png": 3756,
	"./Primoc.png": 450,
	"./cavRoy.png": 5901,
	"./chiali.png": 5903,
	"./dest.png": 4622,
	"./djrouf.png": 9315,
	"./easyMove.png": 4145,
	"./hevean.png": 8184,
	"./kadri.png": 8419,
	"./naturel.png": 7344,
	"./new/Aymen.webp": 7146,
	"./new/Ben_melissa.webp": 8187,
	"./new/Cherif.webp": 5214,
	"./new/Damac_plus.webp": 7728,
	"./new/Dest.webp": 7856,
	"./new/Sidi_attallah.webp": 7783,
	"./new/aghiles.webp": 2397,
	"./new/hebbache.webp": 8813,
	"./products/thuraya.png": 3266,
	"./rekhila.png": 5309,
	"./sotrav.png": 8574,
	"./thuraya.png": 1611,
	"./tis.png": 2105,
	"./yapinov.png": 1991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4995;